// Function for generation query params object adding only not empty values

export function generateQueryParams(params) {
  const result = {};

  Object.keys(params).forEach((key) => {
    if (params[key]) {
      result[key] = params[key];
    }
  });

  return result;
}
